import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../../../api';
import { mfaTokensQueryKeys } from '../constants/queryKeys';
import type { MfaProviderIntegrationConfig } from '../../types';

const END_POINT = '/Settings/externalMfaConfigs';

const fetchExternalMfaConfigs = async (): Promise<MfaProviderIntegrationConfig[]> => {
    const data = await apiGet<MfaProviderIntegrationConfig[]>(END_POINT);
    return data;
};

export const useExternalMfaConfigs = (): UseQueryResult<MfaProviderIntegrationConfig[], Error> => {
    return useQuery({
        queryKey: mfaTokensQueryKeys.externalConfigs(),
        queryFn: fetchExternalMfaConfigs
    });
};
